import CloseIcon from '@mui/icons-material/Close';

/**
 * TitleBar actions for TestDlg.
 * @param {function} onClose
 */
export const TITLE_BAR_ACTIONS = (onClose) => [
    { icon: <CloseIcon sx={{ fontSize: 16 }} />, title: 'Close', onClick: onClose },
];
